// Static service data — hardcoded so services never disappear on reload or API hiccup.

export const MENS_SERVICES = [
  {
    slug: "mens-haircut",
    name: "Haircut",
    price: "$35",
    description: "Precision cut tailored to your personal style. Every detail matters.",
    image: "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  },
  {
    slug: "kids-haircut",
    name: "Kid's Haircut",
    price: "$15+",
    description: "Fun and friendly cuts for our youngest clients. Patient and careful service.",
    image: "https://images.unsplash.com/photo-1622286342621-4bd786c2447c?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  },
  {
    slug: "hair-beard",
    name: "Hair & Beard",
    price: "$43",
    description: "Complete look — full haircut combined with expert beard shaping and lining.",
    image: "https://images.unsplash.com/photo-1593702288056-f1739ec56a01?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  },
  {
    slug: "beard-trim",
    name: "Beard Trim",
    price: "$15",
    description: "Expert beard sculpting, shaping and clean lining for a sharp finish.",
    image: "https://images.unsplash.com/photo-1517832606299-7ae9b720a186?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  },
  {
    slug: "mens-wash",
    name: "Men's Wash",
    price: "$3+",
    description: "Relaxing professional hair wash before your service.",
    image: "https://images.unsplash.com/photo-1559599101-f09722fb4948?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  },
];

export const WOMENS_SERVICES = [
  {
    slug: "womens-haircut",
    name: "Women's Haircut",
    price: "$35",
    description: "Precision cut designed to enhance your natural beauty and personal style.",
    image: "https://images.unsplash.com/photo-1560066984-138dadb4c035?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  },
  {
    slug: "root-color",
    name: "Root Color",
    price: "$65",
    description: "Professional root touch-up to keep your color fresh and vibrant.",
    image: "https://images.unsplash.com/photo-1633681926035-ec1ac984418a?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  },
  {
    slug: "full-color",
    name: "Full Color",
    price: "$95",
    description: "Complete all-over color transformation with professional grade products.",
    image: "https://images.unsplash.com/photo-1605980776566-0486c3ac7617?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  },
  {
    slug: "full-highlights",
    name: "Full Highlights",
    price: "$130+",
    description: "Full head of hand-crafted highlights for maximum dimension and shine.",
    image: "https://images.unsplash.com/photo-1554519515-242161756769?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  },
  {
    slug: "partial-highlights",
    name: "Partial Highlights",
    price: "$65-85",
    description: "Strategic highlights to frame your face and add natural dimension.",
    image: "https://images.unsplash.com/photo-1580618672591-eb180b1a973f?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  },
  {
    slug: "balayage",
    name: "Balayage",
    price: "$250+",
    description: "Luxurious hand-painted color for a seamless natural sun-kissed effect.",
    image: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  },
  {
    slug: "root-balayage",
    name: "Root Balayage",
    price: "$220+",
    description: "Root blending combined with balayage for a perfectly natural grow-out.",
    image: "https://images.unsplash.com/photo-1492106087820-71f1a00d2b11?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  },
  {
    slug: "root-highlights",
    name: "Root Highlights",
    price: "$95",
    description: "Targeted highlights at the root area for a fresh and natural look.",
    image: "https://images.unsplash.com/photo-1605497788044-5a32c7078486?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  },
  {
    slug: "blowdry",
    name: "Blowdry",
    price: "$45+",
    description: "Professional blowout for silky smooth hair with lasting volume and shine.",
    image: "https://images.unsplash.com/photo-1560869713-7d0a29430803?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  },
];

export const ADDONS = [
  { slug: "addon-eyebrows", name: "Eyebrows", price: "$20" },
  { slug: "addon-wash", name: "Wash", price: "$6+" },
  { slug: "addon-style", name: "Style", price: "$10" },
];

// Backwards-compat exports
export const MENS_ADDONS = ADDONS;
export const WOMENS_ADDONS = ADDONS;
